import { render, staticRenderFns } from "./AuthWait.vue?vue&type=template&id=d0de3346"
import script from "./AuthWait.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthWait.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports